module.exports = {"370612001":"宁海街道","370612002":"文化街道","370612004":"武宁街道","370612005":"大窑街道","370612006":"姜格庄街道","370612101":"观水镇","370612105":"龙泉镇","370612106":"玉林店镇","370612107":"水道镇","370612109":"高陵镇","370612110":"王格庄镇","370612111":"昆嵛镇","370612112":"莒格庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370612.json
// module id = 1517
// module chunks = 0